import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionSkill,
  CvSectionSkillItem,
  CvSectionSkillItemResponse,
  CvSectionSkillResponse,
  UpdateCvSectionSkillItemRequest,
} from '@/../gen';

export const namespace = 'cvSectionSkillItemEdit';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionSkill = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_Skill');
export const SetCvSectionSkill = actionCreator<CvSectionSkillResponse>(
  'SET_CV_SECTION_Skill'
);
export const GetCvSectionSkillItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_skill_id: number;
    id: number;
  };
}>('GET_CV_SECTION_SKILL_ITEM');
export const SetCvSectionSkillItem = actionCreator<CvSectionSkillItemResponse>(
  'SET_CV_SECTION_SKILL_ITEM'
);
export const UpdateCvSectionSkillItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_skill_id: number;
    id: number;
  };
  body: UpdateCvSectionSkillItemRequest;
}>('UPDATE_CV_SECTION_SKILL_ITEM');
export const DeleteCvSectionSkillItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_skill_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_SKILL_ITEM');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionSkill: CvSectionSkill;
  cvSectionSkillItem: CvSectionSkillItem;
}

const initialState = (): State => {
  return { cvSectionSkill: null, cvSectionSkillItem: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionSkill, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionSkill(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionSkill(data.data));
    }),
    action(GetCvSectionSkillItem, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionSkillItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_skill_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionSkillItem(data.data));
    }),
    action(UpdateCvSectionSkillItem, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionSkillItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_skill_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionSkillItem(data.data));
    }),
    action(DeleteCvSectionSkillItem, async function(context, action) {
      await this.proffApi.deleteCvSectionSkillItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_skill_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionSkillItem(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionSkill, (state, action) => {
      state.cvSectionSkill = action.payload?.attributes;
    }),
    mutation(SetCvSectionSkillItem, (state, action) => {
      state.cvSectionSkillItem = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionSkill: state => state.cvSectionSkill,
    cvSectionSkillItem: state => state.cvSectionSkillItem,
  },
};
